import React, { FC, useEffect, useState } from 'react';
import styles from '../journey-explorer.module.scss';

const SHOW_SECONDS_AFTER = 3;
const STILL_WORKING_AFTER = 10;

const useElapsedSeconds = (active: boolean): number => {
	const [seconds, setSeconds] = useState(0);

	useEffect(() => {
		setSeconds(0);
		if (!active) {
			return;
		}
		const started = Date.now();
		const timer = window.setInterval(() => setSeconds(Math.floor((Date.now() - started) / 1000)), 1000);
		return () => window.clearInterval(timer);
	}, [active]);

	return seconds;
};

export const LoadingBar: FC<{ active: boolean }> = ({ active }) =>
	active ? <div className={styles.loading_bar} aria-hidden="true" /> : null;

interface LoadingPillProps {
	active: boolean;
	label: string;
	className?: string;
}

export const LoadingPill: FC<LoadingPillProps> = ({ active, label, className }) => {
	const seconds = useElapsedSeconds(active);
	if (!active) {
		return null;
	}
	const text = seconds >= STILL_WORKING_AFTER ? 'Still working on it' : label;
	return (
		<span className={`${styles.loading_pill} ${className ?? ''}`} role="status" aria-live="polite">
			<span className={styles.loading_dot} />
			{text}…{seconds >= SHOW_SECONDS_AFTER && <span className={styles.loading_seconds}>{seconds}s</span>}
		</span>
	);
};
